export const WEBVIEWER3D_URL = process.env.VUE_APP_WEBVIEWER3D_URL;

export enum Viewer3DActions {
    UPLOAD_FROM_LOCAL = 'uploadFromLocal',
    IMPORT_FROM_LOCAL = 'importFromLocal',
    CREATE_ZONE = 'createZone',
    CREATE_4D_BOX = 'create4dBox',
    OPEN_FROM_REPOSITORY = 'openFromRepository',
    IMPORT_FROM_REPOSITORY = 'importFromRepository',
    EXPORT = 'exportFile',
    SAVE = 'saveFile',
    SAVE_AS = 'saveAsFile',
    GENERATE_CUSTOM_ID = 'generateCustomId',
    SYNCHRONISE_FILE = 'synchroniseFile',
    SYNCHRONISE_FILE_BOTTOM_UP = 'synchroniseBottomUp',
    SYNCHRONISE_FILE_TOP_DOWN = 'synchroniseTopDown',
    SET_NODE_PROPERTIES = 'setNodeProperties',
    SAVE_SELECTED_NODE = 'saveSelectedNode',
    CREATE_RESOURCE = 'createResource3D',
    GET_SELECTED_TAKS = 'getSelectedTasks',
    IMPORT_SYNCHRO = 'importSynchro',
    SELECTION_CHANGED = 'selection-changed',
    INITIALIZED = 'initialized',
}

export enum DimensionType {
    '2D' = '2D',
    '3D' = '3D',
}

export enum DialogType {
    SAVE = 'SAVE',
    IMPORT = 'IMPORT',
    OPEN = 'OPEN',
}

export enum ImportSource {
    ABS = 'abs',
    REPOSITORY = 'repository',
}

export const minutesPerHour = 60;

export const defaultOptionsGenerateCustomId = {
    nodeId: 0,
    recursive: true,
    overwrite: false,
    uniqueIds: true,
    includePartNodes: true,
    mode: 'NodePath',
};

export const LIMIT_AMOUNT_FILE_GENERATE_CUSTOMID = 1;

export const action3DPath = {
    create: 'create3dPath',
    createFinish: 'create3dPathFinish',
    cancelCreate3dPath: 'cancelCreate3dPath',

    editing: 'editting3dpath',
    editingFinish: 'editing3dPathFinish',
    cancelEditing3dPath: 'cancelEditing3dPath',

    delete: 'delete3dPath',

    create3dPathBySelection: 'create3dPathBySelection',
    create3dPathBySelectionFinish: 'create3dPathBySelectionFinish',
    cancelCreate3dPathBySelection: 'cancelCreate3dPathBySelection',

    openOrImportFile4D: 'openOrImportFile4D',
    openOrImportFile4DFinish: 'openOrImportFile4DFinish',
};

export const action3DPathError = {
    nodeNotFound: 'error_node-not-found',
    selectionEmpty: 'error_selection-empty',
    node3dPathAssigned: 'error_node-3d-path-assigned',
    nodeNotWire: 'error_node-not-wire',
    selectionMultipleNodes: 'error_selection-multiple-nodes',
};
